import { ReactNode } from "react";

import { EditorElement } from "@smart/itops-serialisation-basic";

export type DisplayLinkProps = {
  element: EditorElement<"link">;
  children: ReactNode;
  disableLinks?: boolean;
};

export const DisplayLink = ({
  children,
  disableLinks,
  element,
}: DisplayLinkProps) =>
  disableLinks ? (
    <span className="text-blue-560">{children}</span>
  ) : (
    <a
      className="text-blue-560"
      href={element.url}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  );
